import React, { useState } from 'react';
import Navbar from '../../components/Navbar/navbar';
import Footer from '../../components/Footer/footer';
import './contact.scss';
import { Link } from 'react-router-dom';
import { FaInstagram, FaTiktok } from 'react-icons/fa';
import emailjs from '@emailjs/browser';
import NewsletterForm from '../../components/newsletter/newsletter';

const Contact = () => {

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [popupMessage, setPopupMessage] = useState(null);

  const sendEmail = (e) => {
    e.persist();
    e.preventDefault();
    setIsSubmitting(true);
    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        e.target,
        process.env.REACT_APP_PUBLIC_KEY
      )
      .then(
        () => {
          setPopupMessage('✅ Message sent successfully!');
          setIsSubmitting(false);
          e.target.reset();
        },
        () => {
          setPopupMessage('❌ Something went wrong. Please try again later.');
          setIsSubmitting(false);
        }
      );
    
    // Clears the form after sending the email
    // e.target.reset();
  };

  const closePopup = () => setPopupMessage(null);
  return (
  <div>
    <Navbar />
  <div className="contact-page">
    {/* Section 1: Chat & Support Options */}
    <section className="contact-options">
      <h2>How can we help?</h2>
      <div className="cards">
        {/* <div className="card chat">
          <h3>Chat With Us</h3>
          <p>Our team is ready to assist you promptly and provide a response that meets your needs.</p>
          <button>Talk to us now</button>
        </div> */}
        <div className="card support">
          <h3>FAQs</h3>
          <p>Our FAQs page answers the most common questions about starting discussions, sharing opinions anonymously, giving and receiving ratings, and navigating the platform with ease.</p>
          <Link to='/faq'><button>FAQs</button></Link>
        </div>
      </div>
    </section>

    {/* Section 2: Contact Form */}
    <section className="contact-section">
      <div className="form-container">
        <h1><span>Get in </span><strong>Touch</strong></h1>
        <p>We’d love to hear from you. Whether you have questions, partnership inquiries, or technical issues, you might find the answer in our <a href='/faq'>FAQs</a>. Otherwise, see all the ways you can speak to our team below.</p>
        <form onSubmit={sendEmail}>
          <input type="text" name="user_name" placeholder="Name *" required />
          <input type="email" name="user_email" placeholder="Email *" required />
          <input type="tel" name="user_phone" placeholder="Phone number *" required />
          <input type="text" name="user_subject" placeholder="Subject *" required />
          <textarea name="user_message" placeholder="Your Message *" required></textarea>
          <button type="submit">SEND</button>
        </form>
        <div className="contact-info">
          <div><span>EMAIL:</span> <a href="mailto:info@taskero.co.uk">founder@orter.co</a></div>
          <div className='socials'><span>SOCIALS:</span> 
          <Link to="https://www.instagram.com/orternetwork?igsh=MXZkODFmNnYxYWR5Ng%3D%3D&utm_source=qr" target="_blank"><FaInstagram /></Link>
          <Link to="https://www.tiktok.com/@orternetwork?_t=ZP-90uIu44x4H9&_r=1" target="_blank"><FaTiktok /></Link>
          </div>
        </div>
      </div>
      {/* <div className="map-container">
        <iframe
          title="location"
          src="https://www.google.com/maps?q=Rumney+Road+West,UK&output=embed"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div> */}
      <div className='map-image'>
        <img src='https://res.cloudinary.com/dsnontai6/image/upload/v1761440061/Screenshot_2025-10-26_at_01.53.15_gz3tkz.png' alt='Map Location' />
      </div>
    </section>

    {/* Section 3: Newsletter Subscription */}
    <section className='subscribe'>
      <NewsletterForm />
    </section>
  </div>
  <Footer />

  {/* Popup Message */}
      {popupMessage && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup-message">
            <p>{popupMessage}</p>
            <button onClick={closePopup}>OK</button>
          </div>
        </div>
      )}
  </div>
)};

export default Contact;
